module.exports = __webpack_public_path__ + "assets/ba87f385f1ec1c2568b55e601156de3e.mp3";